@if (teaserComponentData) {
  <div class="teaserRectangle">
    <div class="teaserRectangle-image">
      <img
        [src]="mediaUrl"
        loading="lazy"
        [alt]="teaserComponentData.imageAltText"
      />
    </div>
    <div
      class="teaserRectangle-content"
      [class.teaserRectangle-content--no-gradient]="
        !(teaserComponentData.backgroundGradient | safeCheck)
      "
    >
      <boels-generic-link-wrapper
        role="button"
        class="teaserRectangle-link"
        [componentData]="teaserComponentData"
        [showArrow]="false"
        [showLink]="false"
        [class.teaserRectangle-link--dark]="
          teaserComponentData.titleColor === backgroundColor.GREY
        "
      >
        <div class="teaserRectangle-link-content">
          <div class="linkText">
            <span class="title">{{ teaserComponentData.title }}</span>
          </div>
          <div class="teaserRectangle-icon">
            <fa-icon class="small" [icon]="arrowRightIcon"></fa-icon>
          </div>
        </div>
      </boels-generic-link-wrapper>
    </div>
  </div>
}
